"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Text_1 = require("../Text/Text");
var Paper_1 = require("../Paper/Paper");
var Alert_styles_1 = __importDefault(require("./Alert.styles"));
function Alert(_a) {
    var className = _a.className, title = _a.title, children = _a.children, themeOverride = _a.themeOverride, color = _a.color, _b = _a.shadow, shadow = _b === void 0 ? 'sm' : _b, others = __rest(_a, ["className", "title", "children", "themeOverride", "color", "shadow"]);
    var classes = Alert_styles_1.default({ color: color, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement(Paper_1.Paper, __assign({ shadow: shadow, className: clsx_1.default(classes.alert, className), themeOverride: themeOverride }, others),
        title && (react_1.default.createElement(Text_1.Text, { themeOverride: themeOverride, "data-mantine-alert-title": true, weight: 700, className: classes.title }, title)),
        react_1.default.createElement("div", { "data-mantine-alert-body": true, className: classes.body }, children)));
}
exports.Alert = Alert;
Alert.displayName = '@mantine/core/Alert';
